import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useManagementLecturer = (target: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lecturerList, setLecturerList] = useState<any[]>();
  const [detailList, setDetailList] = useState<any[]>();
  const [codeList, setCodeList] = useState<any[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const today = new Date();
  const default_start_date = today.getFullYear().toString() + '-01';
  const default_end_date = today.getFullYear().toString() + '-12';

  const { isLoading, refetch } = useQuery(
    [endpoints.management.lecturer, [location.search, target]],
    () =>
      fetcher.management.postLecturer({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : default_start_date,   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : default_end_date,          
        target: target, 
      }),
    {
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setLecturerList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: lecturerDetail } = useMutation(
    [endpoints.management.lecturerDetail],
    fetcher.management.postLecturerDetail,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            setDetailList(res.result?.list);
            break;
          default:
            break;
        }
      },
    },
  )

  return { lecturerList, codeList, detailList, refetch, lecturerDetail };
};

export default useManagementLecturer;
